import React, { FunctionComponent } from "react";

import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { Section } from "../../../ui/Section/Section";
import { Description as DescriptionText } from "../../Tires/Common/Description";
import { SectionHeading } from "../Common/SectionHeading";

type DescriptionProps = {
  part: TirePartItem | null;
};

export const Description: FunctionComponent<DescriptionProps> = ({ part }) => {
  return (
    <Section>
      <SectionHeading translation="searchResults.description" />
      <DescriptionText className="max-h-24 overflow-y-auto" part={part} />
    </Section>
  );
};
